import { SavePlayersToShortlists } from '@statsbomb/kitbag-shortlists';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_RECRUITMENT_LIST_BASE_ROUTE } from '@/hooks/navigation/useRecruitmentListNavigationItem';

type SavePlayersToShortlistsProps = ComponentProps<typeof SavePlayersToShortlists>;

export const SavePlayersToShortlistsWithNavigate = (
  props: Omit<SavePlayersToShortlistsProps, 'onViewShortlistButtonClick'>,
) => {
  const navigate = useNavigate();
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <SavePlayersToShortlists
      {...props}
      onViewShortlistButtonClick={(shortlistId: string) => {
        navigate(`/${language}${DEFAULT_RECRUITMENT_LIST_BASE_ROUTE}/${shortlistId}/players`);
      }}
    />
  );
};
